export default __webpack_public_path__ + "static/media/rightIcon.da193446.svg";